import React, { Component } from 'react';
import {loginToBusinessOwner} from 'base/actions';
import {connect} from 'react-redux';
import {Input} from 'components/vitrade-forms/common';
import {Auth} from 'api';
import {toastr} from 'react-redux-toastr';
import {Link, withRouter} from 'react-router-dom';

class SignInToBusinessForm extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      email: '',
      password: '',
      remember: true
    }
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  submitForm(e) {
    e.preventDefault();

    this.props.dispatch(loginToBusinessOwner(this.state.email, this.refs.password.validator.input.value, this.props.businessId)).then(response => {
      this.setState({loading: false});
      if (response.isAuthenticated === true) {
        toastr.success('Thành công!', `Đã đăng nhập vào tài khoản chủ doanh nghiệp: ${response.business.name}`);

        // window.location = this.props.defaultPage;
        this.props.history.push('/my-business/dashboard');
      } else {
        toastr.error('Đăng nhập thất bại!', 'Sai email hoặc mật khẩu.');
      }
    }).catch(err => {
      console.log(err)
    });
  }

  render() {
    return (
      <div className="signin-box" style={{padding: 0}}>
        <div className="register-logo" style={{fontSize: 20}}>
          <b>Đăng nhập doanh nghiệp</b>
        </div>

        <div className="register-box-body" style={{padding: 10}}>
          <form onSubmit={this.submitForm.bind(this)}>
            <Input type="email" placeholder="Email..."
              className='has-feedback fg-custom'
              iconClassName='fa-at'
              value={this.state.email}
              onChange={this.onChange.bind(this, 'email')}
            />

            <Input type="password" placeholder="Mật khẩu..."
              className='has-feedback fg-custom'
              iconClassName='fa-unlock-alt'
              ref='password'
            />

            <button type="submit" className="btn btn-primary btn-block btn-flat btn-submit text-btn">ĐĂNG NHẬP</button>
          </form>
        </div>
      </div>
    );
  }
}


SignInToBusinessForm.defaultProps = {
  defaultPage: '/dashboard'
}

const bindStateToProps = state => {
  return {
    auth: state.appAuth
  }
}

export default withRouter(connect(bindStateToProps)(SignInToBusinessForm));



// WEBPACK FOOTER //
// ./components/business/business-page/SignInToBusinessForm.jsx